import { Injectable } from "@angular/core";
import { HttpParams } from "@angular/common/http";
import { HttpService } from "../http.service";
import { ADMIN_API_ENDPOINTS } from "../../common/api-endpoints";
import { PageResultDto, GovernTenantDto } from "@api/dto";

const BASE = ADMIN_API_ENDPOINTS.OFFLINE_TENANT_ORDERING;
const OFFLINE_TENANTS_PATH = `${BASE}/offline-tenants`;

export interface UpdateOfflineTenantOrderingDto {
  orderingEnabled?: boolean;
  fnbCategoryId?: string | null;
  /** List of F&B sub-category IDs to assign to the tenant */
  fnbCategoryIds?: string[];
  telegramGroupId?: string | null;
  paywayTenantId?: string | null;
}

@Injectable({ providedIn: "root" })
export class OfflineTenantOrderingApiService {
  constructor(private readonly httpService: HttpService) {}

  async getOfflineTenants(
    params: HttpParams | Record<string, unknown>
  ): Promise<{ rows: GovernTenantDto[]; count: number }> {
    const result = await this.httpService.get<PageResultDto<GovernTenantDto>>(
      OFFLINE_TENANTS_PATH,
      params
    );
    return {
      rows: result?.rows ?? [],
      count: result?.count ?? 0,
    };
  }

  async update(
    id: string,
    body: UpdateOfflineTenantOrderingDto
  ): Promise<GovernTenantDto> {
    const payload: Record<string, unknown> = {};
    if (body.orderingEnabled !== undefined) payload.orderingEnabled = body.orderingEnabled;
    if (body.fnbCategoryId !== undefined) payload.fnbCategoryId = body.fnbCategoryId ?? undefined;
    if (body.fnbCategoryIds !== undefined) payload.fnbCategoryIds = body.fnbCategoryIds ?? [];
    if (body.telegramGroupId !== undefined) payload.telegramGroupId = body.telegramGroupId ?? undefined;
    if (body.paywayTenantId !== undefined) payload.paywayTenantId = body.paywayTenantId ?? undefined;
    return this.httpService.put<GovernTenantDto>(`${BASE}/${id}`, payload);
  }

  async findOne(id: string): Promise<GovernTenantDto | null> {
    try {
      const result = await this.httpService.get<GovernTenantDto>(`${BASE}/${id}`);
      return result ?? null;
    } catch {
      return null;
    }
  }
}
